<template>
  <div
    v-if="responsiveMenu && menuOpen"
    class="absolute inset-x-0 top-full bg-white z-50 h-fit max-h-screen w-screen text-blue-1 border-b border-b-grey-4 shadow-md rounded-b">
    <BaseSection class="py-8! md:px-8! relative">
      <div
        v-for="(menu, index) in menus"
        :class="{ 'border-b-grey-4 border-b': menus.length - 1 !== index }"
        :key="`menu-${index}`"
        class="py-4">
        <div class="flex justify-between align-middle" @click="toggle(index)">
          <div class="mh6 md:b1 text-grey-1">{{ menu.name }}</div>
          <Chevron
            class="w-6 fill-grey-3 stroke-grey-3 stroke-1 my-1 shrink-0 mr-4 transition duration-200 ease-in-out"
            :class="{ 'rotate-180': sectionOpen == index }" />
        </div>
        <div
          v-if="sectionOpen == index"
          class="flex flex-col gap-y-3 transition duration-200 ease-in-out pt-3"
          :class="{ 'h-[0.1px] opacity-0': sectionOpen !== index }">
          <RouterLink
            v-for="{ name, link, label } in menu.links"
            :key="`menu-${index}-${name}`"
            :to="link"
            class="w-full no-underline button-2 text-lg! hover:text-primary text-grey-2 py-3 rounded"
            active-class="text-white! fill-primary!"
            @click="mobileNavigate"
            >{{ label }}
          </RouterLink>
        </div>
      </div>
      <div class="grid md:grid-cols-2 gap-4 mt-8">
        <OtivoButton
          class="w-full whitespace-nowrap mx-auto"
          colour="blue"
          size="large"
          @click="createAccount"
          >Get started
        </OtivoButton>
        <RouterLink v-slot="{ navigate }" :to="{ name: 'login' }" class="w-full">
          <OtivoButton
            class="w-full whitespace-nowrap mx-auto"
            colour="white"
            size="large"
            @click="navigate"
            >Log in
          </OtivoButton>
        </RouterLink>
      </div>
    </BaseSection>
  </div>
</template>

<script lang="ts" setup>
import { useMediaQuery } from '@vueuse/core'
import { useMenus } from '@/composables/useMenus.ts'
import BaseSection from '@/app/components/BaseSection.vue'
import Chevron from '@/components/SVGS/BrandIcons/16px/chevron-closed.svg'
import { computed, inject, ref, Ref } from 'vue'
import OtivoButton from '@/components/OtivoButton.vue'
import { createAccount } from '@/lib/AuthenticatorPlugin.ts'

const menuOpen = inject('headerNavOpen') as Ref<boolean>

const menus = computed(() => useMenus().cfsD2dMenus.filter((menu) => menu.name !== 'Legal stuff'))
console.log('menus', menus)

const responsiveMenu = useMediaQuery('(max-width: 1023px)')

const sectionOpen = ref<number | null>(null)

const toggle = (index: number) => {
  sectionOpen.value = sectionOpen.value === index ? null : index
}
const mobileNavigate = () => {
  menuOpen.value = false
  sectionOpen.value = null
}
</script>

<style scoped>
::deep(.plan-icon) {
  width: 2.5rem;
  height: 2.5rem;
}
</style>
